import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "../firebase";
import React, { Component } from "react";
import { withNavigation } from "../withNavigation";
import "../Auth.css";

class ForgotPassword extends Component {
  constructor() {
    super();

    this.state = {
      mobile: "",
      otp: "",
      password: "",
      confirmPassword: ""
    };
  }


  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };




  // ✅ SEND OTP
  sendOtp = async () => {
    this.setState({ loading: true });

    try {
      const mobile = this.state.mobile?.trim();

      if (!mobile || mobile.length !== 10) {
        alert("Enter valid mobile number ❌");
        this.setState({ loading: false });
        return;
      }
      const phoneNumber = "+91" + mobile;

      // clear old recaptcha
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear();
      }

      // ✅ correct order
      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,
        "recaptcha",
        {
          size: "invisible"
        }
      );

      const appVerifier = window.recaptchaVerifier;

      const confirmationResult = await signInWithPhoneNumber(
        auth,
        phoneNumber,
        appVerifier
      );

      window.confirmationResult = confirmationResult;

      alert("OTP Sent ✅");

    } catch (err) {
      console.log("ERROR:", err);
      alert(err.message);
      this.setState({ loading: false });
    }
  };





  verifyOtp = async () => {
    try {
      const code = this.state.otp;

      if (!code || code.length !== 6) {
        alert("Enter valid OTP ❌");
        return;
      }

      // ✅ STEP 1: Firebase OTP verify
      const result = await window.confirmationResult.confirm(code);

      const user = result.user;
      console.log("Verified User:", user);

      // ✅ STEP 2: Backend call (AFTER verification)
      const res = await fetch("https://api.hi-bigame.online/update-password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          mobile: this.state.mobile,
          password: this.state.password
        })
      });

      const data = await res.json();

      alert(data.message);
      // this.props.navigate("/login")
      window.location.href = "/";

    } catch (err) {
      console.log(err);
      alert("Invalid OTP ❌");
    }
  };


  render() {
    return (
      <div className="auth-bg">

        <div className="auth-card">

          <div className="logo"> HI-BI</div>

          <h3> Forgot Password</h3>

          <p className="field-title"> Mobile Number </p>

          <input className="auth-input" type="tel" name="mobile" placeholder="Enter Mobile Number"
            value={this.state.mobile} onChange={this.handleChange} />

          <button className="auth-btn" onClick={this.sendOtp} disabled={this.state.loading}>
            {this.state.loading ? "Sending..." : "Send OTP"}</button>

          <p className="field-title"> OTP </p>

          <input className="auth-input" name="otp" placeholder="Enter OTP"
            value={this.state.otp} onChange={this.handleChange} />

          <p className="field-title"> New Password</p>

          <input className="auth-input" type="password" name="password" placeholder="New Password"
            value={this.state.password} onChange={this.handleChange} />

          <p className="field-title"> Confirm Password </p>

          <input className="auth-input" type="password" name="confirmPassword" placeholder="Confirm Password"
            value={this.state.confirmPassword} onChange={this.handleChange} />

          <button className="auth-btn" onClick={this.verifyOtp} > Update Password</button>
          <div id="recaptcha"></div>
          <div className="link" onClick={() => this.props.navigate("/")}>Back to Login</div>

        </div>

      </div>
    );
  }
}

export default withNavigation(
  ForgotPassword
);


